export interface IconKeyOption {
  key: string;
  labelKey?: string;
}

export const ICON_KEY_OPTIONS: readonly IconKeyOption[] = [
  { key: 'category', labelKey: 'iconKeys.category' },
  { key: 'shopping_cart', labelKey: 'iconKeys.shopping_cart' },
  { key: 'local_grocery_store', labelKey: 'iconKeys.local_grocery_store' },
  { key: 'local_mall', labelKey: 'iconKeys.local_mall' },
  { key: 'store', labelKey: 'iconKeys.store' },
  { key: 'restaurant', labelKey: 'iconKeys.restaurant' },
  { key: 'fastfood', labelKey: 'iconKeys.fastfood' },
  { key: 'local_cafe', labelKey: 'iconKeys.local_cafe' },
  { key: 'local_bar', labelKey: 'iconKeys.local_bar' },
  { key: 'cake', labelKey: 'iconKeys.cake' },
  { key: 'directions_car', labelKey: 'iconKeys.directions_car' },
  { key: 'local_gas_station', labelKey: 'iconKeys.local_gas_station' },
  { key: 'commute', labelKey: 'iconKeys.commute' },
  { key: 'train', labelKey: 'iconKeys.train' },
  { key: 'directions_bus', labelKey: 'iconKeys.directions_bus' },
  { key: 'directions_bike', labelKey: 'iconKeys.directions_bike' },
  { key: 'local_taxi', labelKey: 'iconKeys.local_taxi' },
  { key: 'home', labelKey: 'iconKeys.home' },
  { key: 'apartment', labelKey: 'iconKeys.apartment' },
  { key: 'weekend', labelKey: 'iconKeys.weekend' },
  { key: 'build', labelKey: 'iconKeys.build' },
  { key: 'cleaning_services', labelKey: 'iconKeys.cleaning_services' },
  { key: 'bolt', labelKey: 'iconKeys.bolt' },
  { key: 'water_drop', labelKey: 'iconKeys.water_drop' },
  { key: 'local_laundry_service', labelKey: 'iconKeys.local_laundry_service' },
  { key: 'phone_iphone', labelKey: 'iconKeys.phone_iphone' },
  { key: 'wifi', labelKey: 'iconKeys.wifi' },
  { key: 'computer', labelKey: 'iconKeys.computer' },
  { key: 'medical_services', labelKey: 'iconKeys.medical_services' },
  { key: 'local_hospital', labelKey: 'iconKeys.local_hospital' },
  { key: 'local_pharmacy', labelKey: 'iconKeys.local_pharmacy' },
  { key: 'fitness_center', labelKey: 'iconKeys.fitness_center' },
  { key: 'school', labelKey: 'iconKeys.school' },
  { key: 'menu_book', labelKey: 'iconKeys.menu_book' },
  { key: 'child_care', labelKey: 'iconKeys.child_care' },
  { key: 'pets', labelKey: 'iconKeys.pets' },
  { key: 'checkroom', labelKey: 'iconKeys.checkroom' },
  { key: 'spa', labelKey: 'iconKeys.spa' },
  { key: 'redeem', labelKey: 'iconKeys.redeem' },
  { key: 'flight_takeoff', labelKey: 'iconKeys.flight_takeoff' },
  { key: 'hotel', labelKey: 'iconKeys.hotel' },
  { key: 'beach_access', labelKey: 'iconKeys.beach_access' },
  { key: 'movie', labelKey: 'iconKeys.movie' },
  { key: 'theaters', labelKey: 'iconKeys.theaters' },
  { key: 'music_note', labelKey: 'iconKeys.music_note' },
  { key: 'sports_soccer', labelKey: 'iconKeys.sports_soccer' },
  { key: 'sports_esports', labelKey: 'iconKeys.sports_esports' },
  { key: 'subscriptions', labelKey: 'iconKeys.subscriptions' },
  { key: 'savings', labelKey: 'iconKeys.savings' },
  { key: 'payments', labelKey: 'iconKeys.payments' },
  { key: 'attach_money', labelKey: 'iconKeys.attach_money' },
  { key: 'monetization_on', labelKey: 'iconKeys.monetization_on' },
  { key: 'account_balance_wallet', labelKey: 'iconKeys.account_balance_wallet' },
  { key: 'account_balance', labelKey: 'iconKeys.account_balance' },
  { key: 'credit_card', labelKey: 'iconKeys.credit_card' },
  { key: 'receipt_long', labelKey: 'iconKeys.receipt_long' },
  { key: 'request_quote', labelKey: 'iconKeys.request_quote' },
  { key: 'price_check', labelKey: 'iconKeys.price_check' },
  { key: 'trending_up', labelKey: 'iconKeys.trending_up' },
  { key: 'pie_chart', labelKey: 'iconKeys.pie_chart' },
  { key: 'account_circle', labelKey: 'iconKeys.account_circle' },
  { key: 'work', labelKey: 'iconKeys.work' },
  { key: 'business_center', labelKey: 'iconKeys.business_center' },
  { key: 'event', labelKey: 'iconKeys.event' },
  { key: 'event_repeat', labelKey: 'iconKeys.event_repeat' },
  { key: 'celebration', labelKey: 'iconKeys.celebration' },
  { key: 'security', labelKey: 'iconKeys.security' },
  { key: 'public', labelKey: 'iconKeys.public' },
  { key: 'volunteer_activism', labelKey: 'iconKeys.volunteer_activism' },
];
